import {IndexFilters, type CheckboxGroupProps} from '../../IndexTemplate/components/IndexFilters/IndexFilters'
import type {Filters, SelectedFilters} from '../types'

type AsideProps = {
  filters: Filters
  selectedFilters?: SelectedFilters
}

export const Aside = ({filters, selectedFilters}: AsideProps) => {
  const checkboxGroups: CheckboxGroupProps[] = filters
    .filter(({concepts}) => concepts.length > 0)
    .map(({scheme, concepts}) => {
      const selectedIds = selectedFilters?.[scheme.id] || []
      return {
        value: scheme.id,
        label: scheme.preferred_label ?? scheme.id,
        checkboxes: concepts.map(concept => ({
          label: concept.preferred_label,
          value: concept.id,
          isChecked: selectedIds.includes(concept.id),
        })),
      }
    })

  return <IndexFilters checkboxGroups={checkboxGroups} />
}
